import { classMap } from 'lit-html/directives/class-map.js';
import { repeat } from 'lit-html/directives/repeat.js';
import { styleMap } from 'lit-html/directives/style-map.js';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { html, render } from 'lit-html/lit-html.js';
import DomDiff from './dom-diff/DomDiff.js';
import KompisElementPropertyDecorator from './kompis-element/decorators/KompisElementPropertyDecorator.js';
import KompisElement from './kompis-element/KompisElement.js';
import KompisElementRegistry from './registry/KompisElementRegistry.js';
import CssTemplateLiteralTag from './template/CssTemplateLiteralTag.js';
import HtmlTemplateLiteralTag from './template/HtmlTemplateLiteralTag.js';
const css = CssTemplateLiteralTag.templateToString;
const htmlString = HtmlTemplateLiteralTag.templateToString;
const property = KompisElementPropertyDecorator;
export { classMap, css, DomDiff, html, htmlString, KompisElement, KompisElementRegistry, property, render, repeat, styleMap, unsafeHTML };
//# sourceMappingURL=index.js.map